app.controller('mainController', function (
    $scope,
    $rootScope,
    objectService
) {
    $rootScope.errors  = []
    
    $rootScope.QUESTION_TYPE      = QUESTION_TYPE
    $rootScope.STATUS             = STATUS
    $rootScope.CONFIGURATION_TYPE = CONFIGURATION_TYPE

    $scope.slideshow   = 1
    $scope.environment = null

    $scope.reviewMode  = objectService.getReviewMode.bind(objectService)
    $scope.readOnly    = objectService.readOnly
    $scope.demoMode    = objectService.getDemoMode.bind(objectService)

    $scope.status      = objectService.getStatus.bind(objectService)
    $scope.STATUSES    = objectService.statuses

    $scope.endReview   = function(){
        objectService.setReviewMode(false)
    }
});
